import { defineQuery } from '@rocicorp/zero';
import * as z from 'zod';
import { zql } from '../zero-schema.gen.js';
import { applyCursor } from '../util/apply-cursor.js';
export const ListOrganisationsInput = z.object({
    cursor: z
        .object({
        id: z.string(),
        createdAt: z.number(),
        direction: z.enum(['forward', 'backward']).default('forward'),
    })
        .optional(),
    sort: z.object({
        field: z.enum(['createdAt']),
        dir: z.enum(['asc', 'desc']).default('desc'),
    }),
    limit: z.number().optional(),
    filters: z
        .object({
        search: z.string().optional(),
        status: z.enum(['active', 'suspended']).optional(),
        type: z.enum(['HOSPITAL', 'PRIVATE_PHARMACY']).optional(),
    })
        .optional(),
});
export const organisations = {
    listOrganisations: defineQuery(ListOrganisationsInput, params => {
        const input = params.args;
        let q = zql.organisation
            .where('deletedAt', 'IS', null)
            .related('licences', l => l.orderBy('createdAt', 'desc').limit(1));
        if (input.filters?.search?.trim()) {
            const term = `%${input.filters.search.trim()}%`;
            q = q.where(({ cmp }) => cmp('name', 'ILIKE', term));
        }
        if (input.filters?.status) {
            q = q.where('status', '=', input.filters.status);
        }
        if (input.filters?.type) {
            q = q.where('type', '=', input.filters.type);
        }
        q = applyCursor(q, { cursor: input.cursor, sort: input.sort, limit: input.limit });
        return q;
    }),
    getOrganisationById: defineQuery(z.string(), params => {
        return zql.organisation
            .where('id', '=', params.args)
            .where('deletedAt', 'IS', null)
            .related('licences', l => l.orderBy('createdAt', 'desc'))
            .related('users', l => l.where('deletedAt', 'IS', null))
            .one();
    }),
    // getOrganisationActivitiesById: defineQuery(z.string(), params => {
    //   // TODO: implement when event log infrastructure is added
    //   // return zql.eventLogs
    //   //   .where('resource', '=', 'organisation')
    //   //   .where('resourceId', '=', params.args)
    //   //   .orderBy('performedAt', 'desc')
    // }),
};
//# sourceMappingURL=organisation.queries.js.map